var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useMemo, useState } from 'react';
import { useLoaderData } from 'react-router';
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button } from "../../../Components/UI";
import { templatesAtom } from "../../../atoms";
import { useAtomValue } from 'jotai';
import { Translate } from "../../../../I18N";

import { formatEntityData } from "./utils/formatters";
import { EntitiesTable } from "./components/entities/Table";
import { generateDisplayPill } from "./utils/generateDisplayPill";
import { ExtractEntitiesDialog } from "./components/entities/ExtractEntitiesDialog";
import { DeleteDialog } from "./components/entities/DeleteDialog";
import { FilterSidePanel } from "./components/FilterSidePanel";

const DisplayPill = generateDisplayPill({
  label: 'New'
});

const PXEntityDashboard = () => {
  const [sourceTemplate, setSourceTemplate] = useState();
  const { entities = [], filters = [] } = useLoaderData();




  const templates = useAtomValue(templatesAtom);
  const pxEntitiesData = useMemo(
    () => formatEntityData(entities, templates),
    [entities, templates]
  );

  const [isSaving, setIsSaving] = useState(false);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const [entityDatum] = pxEntitiesData;
    setSourceTemplate(entityDatum.template);
  }, [pxEntitiesData]);

  const [newEntitiesCount] = useState(
    pxEntitiesData.filter((entity) => entity.status === 'NEW').length
  );

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-paragraph-extractor",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: (sourceTemplate === null || sourceTemplate === void 0 ? void 0 : sourceTemplate.name) || '',
      path: new Map([['Paragraph extraction', '/settings/paragraph-extraction']]) }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(EntitiesTable, {
      pxEntitiesData: pxEntitiesData,
      onSelectionChange: setSelected,
      sourceTemplate: sourceTemplate,
      filters: filters }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "flex gap-2", highlighted: (selected === null || selected === void 0 ? void 0 : selected.length) > 0 }, void 0,
    (selected === null || selected === void 0 ? void 0 : selected.length) === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      className: "disabled:opacity-50",
      onClick: () => console.log('extract new paragraphs'),
      disabled: isSaving || newEntitiesCount === 0 }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Extract new paragraphs")
    ), /*#__PURE__*/
    _jsx(DisplayPill, { count: newEntitiesCount })
    ),

    (selected === null || selected === void 0 ? void 0 : selected.length) > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(ExtractEntitiesDialog, {
      setIsProcessing: setIsSaving,
      onSuccess: () => {
        setSelected([]);
      },
      selected: selected,
      disabled: isSaving }
    ), /*#__PURE__*/
    _jsx(DeleteDialog, {
      setIsProcessing: setIsSaving,
      disabled: isSaving,
      onSuccess: () => {
        setSelected([]);
      },
      selected: selected }
    ), /*#__PURE__*/
    _jsx("div", { className: "text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), ' ', /*#__PURE__*/
    _jsx("span", { className: "text-gray-900 font-semibold" }, void 0, selected.length), ' ', /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of"), ' ', /*#__PURE__*/
    _jsx("span", { className: "text-gray-900 font-semibold" }, void 0, pxEntitiesData.length)
    )
    )

    )
    ),
    filters.length > 0 && /*#__PURE__*/_jsx(FilterSidePanel, { availableFilters: filters })
    ));

};

export { PXEntityDashboard };